import { onMounted, computed } from 'vue'

import { useService } from '@store/service.js'
const $service = useService()

import { useStaff } from '@store/staff.js'
const $staff = useStaff()

import { useCustomer } from '@store/customer.js'
const $customer = useCustomer()

import moment from 'moment'

export const useContent = () => {
    onMounted(() => {
        $service.fetchData()
        $staff.fetchData()
        $customer.fetchCustomers()
    })


    const business = prebook_admin.settings.business || {}
    const countries = prebook_admin.options.countries || {}
    const business_hours = prebook_admin.settings.business_hours || {}


    const businessAddress = computed(() => {
        let addressParts = [
            business.street,
            business.state,
            business.city,
            business.zip_code,
            countries.find(c => c.code == business.country)?.name
        ]

        // filter out empty or undefined parts
        addressParts = addressParts.filter(part => part?.trim?.() !== '')

        // return the formatted address or "N/A" if empty
        return addressParts.length ? addressParts.join(', ') : "N/A"
    })


    const overviewContent = computed(() => {
        // real content
        let service = $service.getServices[0]
        let staff = $staff.getStaffs[0]
        let customer = $customer.getCustomers[0]
        let address = businessAddress.value
        let date = moment().add(1, 'day')
        let businessDay = business_hours[moment().format('dddd')]
        let time = moment(businessDay.enabled ? business_hours[moment().format('dddd')].hours[0].start : '10:00 AM', 'h:mm A').format('h:mm A')

        // dummy contents
        let dummyService = {
            name: 'Dental Examination',
            meta: {
                duration: 30,
                duration_unit: 'minute',
                price: 100
            }
        }

        let dummyStaff = {
            display_name: 'Dr. John Doe',
            meta: {
                color: '#FF4405',
            }
        }

        let dummycustomer = {
            display_name: 'Dr. John Doe',
            meta: {
                color: '#FF4405',
            }
        }

        let dummyAddress = '6391 Elgin St. Celina, Delaware 10299'


        // let dummyTIme = '10:00 AM'

        return {
            service: service || dummyService,
            staff: staff || dummyStaff,
            customer: customer || dummycustomer,
            address: address !== "N/A" ? address : dummyAddress,
            date: date,
            time: time
        }
    })
    return { overviewContent }
}